import React from 'react';

export default function ReturnsConfirmationBlock({
  retailerAddress,
  returnGuid,
  isPrintInStore,
  isUnlabelledLocker,
  isCsGenerated,
  customerEmail,
  isStoreComponents,
  isLockersComponents,
  useInPostRetailerPageNewCopy
}) {
  return (
    <>
      {isStoreComponents && (
        <div>      
          <div className="retailer__show-return-details">
            <div className="retailer__show-returns-address">
              <div
                dangerouslySetInnerHTML={{
                  __html: retailerAddress.replace(/\r?\n/g, '<br>'),
                }}
              />
            </div>

            <div className="retailer__show-call-to-action">
              <a
                className="yodel-outline-button"
                target="_blank"
                rel="noopener noreferrer"
                href={
                  isPrintInStore
                    ? `/returns/${returnGuid}/print_in_store.html`
                    : `/returns/${returnGuid}/label.pdf`
                }
              >
                {isPrintInStore ? 'View barcode' : 'Print label'}
              </a>
            </div>
          </div>

          <div>
            {isCsGenerated ? (
              <p>{`We have also emailed ${customerEmail} a link to the label.`}</p>
            ) : (
              <>
                <p>
                  {isPrintInStore ? (
                    <span>
                      {useInPostRetailerPageNewCopy
                        ? "Simply drop off your parcel at any InPost Shop. "
                        : "Simply drop off your parcel at any Yodel Store. "}
                    </span>
                  ) : (
                    <span>
                      {useInPostRetailerPageNewCopy
                        ? "You're all set. Simply attach your label securely to your parcel and drop it off at any InPost Shop. "
                        : "Simply attach your label securely to your parcel and drop it off at any Yodel Store. "}
                    </span>
                  )}
                  <a href="/store-locator?search_filter=paypoint" target="_blank" rel="noopener noreferrer">
                    {useInPostRetailerPageNewCopy ? "Click here to find an InPost Shop near you" : "Click here to find a store near you"}
                  </a>
                  .
                  {useInPostRetailerPageNewCopy && !isPrintInStore && (
                    <>
                      {' '}
                      <b>You can only return this parcel at an InPost Shop, and not in an InPost Locker.</b>
                    </>
                  )}
                </p>
                <p>
                  {useInPostRetailerPageNewCopy ? (
                    "The shopkeeper will scan your parcel and you'll be given a receipt. Please allow at least 5 working days for your return to make its way back to the retailer."
                    ) : (
                    "The shopkeeper will scan your parcel and you will be given a receipt as proof of postage. Please allow 5 working days before contacting us regarding your delivery."
                  )}
                </p>
                <p>
                  {useInPostRetailerPageNewCopy ? (
                    "When sending a return label, ensure any previous labels are removed or covered with the new label."
                  ) : (
                    "When sending a return parcel please ensure that any previous labels used are removed or completely covered with the new returns label."
                  )}
                </p>
              </>
            )}
          </div>
        </div>
      )}
      
      {isLockersComponents && (
        <div>   
          <div className="retailer__show-return-details">
            <div className="retailer__show-returns-address">
              <div
                dangerouslySetInnerHTML={{
                  __html: retailerAddress.replace(/\r?\n/g, '<br>'),
                }}
              />
            </div>

            <div className="retailer__show-call-to-action">
              <a
                className="yodel-outline-button"
                target="_blank"
                rel="noopener noreferrer"
                href={`/returns/${returnGuid}/label.pdf`}
              >
                {isUnlabelledLocker ? 'View QR code' : 'Print label'}
              </a>
            </div>
          </div>
          <div>
            <>
              <p>
                Simply attach your label securely to your parcel and drop it off at any InPost Locker.{' '}
                <a href="/store-locator?search_filter=in_post_locker" target="_blank" rel="noopener noreferrer">
                  Click here to find an InPost Locker near you
                </a>
                .
              </p>
            {isUnlabelledLocker ? (
              <>
                <p>
                  Show your QR code at the locker to access it, pop your parcel in the compartment and we’ll do the rest.
                </p>
                <p>
                  Please ensure any previous labels are removed from your parcel before returning it. 
                  You can track your return on our website or app.
                </p>
              </>
            ) : (
              <>
                <p>
                  The shopkeeper will scan your parcel and you'll be given a receipt.
                  Please allow 5 working days for your return to make its way back to the retailer.
                </p>

                <p>
                  When sending a return label, ensure any previous labels are removed or covered with the new label.
                </p>
              </>
            )}
            </>
          </div>
        </div>
      )}
    </>
  );
}
